import { render, staticRenderFns } from "./ContentListComponent.vue?vue&type=template&id=c54ba4d0&scoped=true&"
import script from "./ContentListComponent.vue?vue&type=script&lang=js&"
export * from "./ContentListComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContentListComponent.vue?vue&type=style&index=0&id=c54ba4d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54ba4d0",
  null
  
)

export default component.exports